import { DeviceDiskUsed } from '@cdw-ae/common-data';
import type { SelectionOption } from '@cdw-ae/filter-bar-interfaces';

export const DEVICE_STATUS_OPTIONS: SelectionOption[] = [
  { name: 'ACTIVE', displayName: 'Active' },
  { name: 'DISABLED', displayName: 'Disabled' },
  { name: 'DEPROVISIONED', displayName: 'Deprovisioned' },
  { name: 'INACTIVE', displayName: 'Inactive' },
];

export const BATTERY_HEALTH_OPTIONS: SelectionOption[] = [
  { name: 'UNSPECIFIED', displayName: 'Unspecified' },
  { name: 'NORMAL', displayName: 'Normal' },
  { name: 'SOON', displayName: 'Soon (Replace Soon)' },
  { name: 'NOW', displayName: 'Now (Replace Now)' },
];

export const DISK_USED_OPTIONS: SelectionOption[] = [
  { name: DeviceDiskUsed.Low, displayName: 'Low (< 50%)' },
  { name: DeviceDiskUsed.Fifty, displayName: '50%' },
  { name: DeviceDiskUsed.Sixty, displayName: '60%' },
  { name: DeviceDiskUsed.Seventy, displayName: '70%' },
  { name: DeviceDiskUsed.Eighty, displayName: '80%' },
  { name: DeviceDiskUsed.Ninety, displayName: '90%' },
];

const truncate = (v: string, maxLen = 25): string =>
  v.length > maxLen ? `${v.substring(0, maxLen)}...` : v;

/**
 * Extract values array from either a plain JSON array or a structured
 * MultiTextSearch object: {"mode":"contains","values":["..."]}
 */
const extractMultiValues = (value: string): string[] => {
  const parsed = JSON.parse(value);
  if (Array.isArray(parsed)) return parsed;
  if (parsed && typeof parsed === 'object' && Array.isArray(parsed.values))
    return parsed.values;
  return [String(parsed)];
};

export const multiContainsChipFormatter = (value: string): string => {
  try {
    const values = extractMultiValues(value);
    if (values.length === 0) return '';
    if (values.length === 1) return `: ${truncate(values[0])}`;
    return `: ${truncate(values[0])} +${values.length - 1} more`;
  } catch {
    return `: ${value}`;
  }
};

export const multiContainsToolTipFormatter = (value: string): string => {
  try {
    const values = extractMultiValues(value);
    return values.join(', ');
  } catch {
    return value;
  }
};